import { useState, useEffect } from 'react';

export function LoadingSpinner({ delay = 0 }: { delay?: number }) {
  const [show, setShow] = useState(delay <= 0);

  useEffect(() => {
    if (delay <= 0) return;
    const t = setTimeout(() => setShow(true), delay);
    return () => clearTimeout(t);
  }, [delay]);

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      height: '100vh', background: 'var(--bg-primary)',
    }}>
      {show && <div className="animate-breath" style={{
        width: 48, height: 1, background: 'var(--accent-primary)',
      }} />}
    </div>
  );
}
